import { useMutation } from "@apollo/client";
import { ICardCreateResponse, ISquareTokenizeResponse } from "./card-create.interface";
import { mapToCardCreateRequest } from "./card-create.mapper";
import { CARD_CREATE } from "./card-create.mutation";
import { CardCreateFormType } from "./card-create.schema";

export const useCardCreate = () => {
  const [createCard, { data, loading, error }] = useMutation<{ createCard: ICardCreateResponse }>(CARD_CREATE);

  const getCreateCard = (tokenize: ISquareTokenizeResponse, cardCreateForm: CardCreateFormType) => {
    const cardRequest = mapToCardCreateRequest(tokenize, cardCreateForm);

    createCard({
      variables: { card: cardRequest },
    });
  };

  return {
    getCreateCard,
    cardCreated: data?.createCard,
    loading,
    error,
  };
};
